/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { QuestionData } from '../data';
import { accent2, gray5 } from '../Styles';
import { Question } from './Question';

interface Props {
    data: QuestionData[];
    showCategory: boolean;
    showLabels: boolean;
}

export const QuestionList = ({ data, showCategory, showLabels }: Props) => (
    <ul
        css={css`
            list-style: none;
            margin: 10px 10px 50px 10px;
            padding: 0 20px;
            background-color: #fff;
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
            border-top: 3px solid ${accent2};
            box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.16);
        `}
    >
        {data.map((question) => (
            <li
                key={question.questionId}
                css={css`
                    border-top: 1px solid ${gray5};
                    :first-of-type {
                        border-top: none;
                    }
                `}
            >
                <Question
                    key={question.questionId}
                    data={question}
                    showCategory={showCategory}
                    showLabels={showLabels}
                />
            </li>
        ))}
    </ul>
);
